import { handleActions } from 'redux-actions';
import { fromJS, List, Map } from 'immutable';
import {
  closeModal,
  endLoading,
  fetchAccountAction,
  fetchAccountsAction,
  fetchCalendars,
  fetchEvents,
  fetchNativeEventsAction,
  fetchOrganizationsAction,
  fetchOrganizers,
  fetchSettings,
  fetchTicketSpotEvents,
  fetchUser,
  filterEventsAction,
  getCampaignsAction,
  openModal,
  startLoading,
  updateCampaignAction,
  updateSettings,
  updateSettingsProp,
  updateUserAction,
  setJourneySessionId,
} from '../actions/component_actions';

const initialState = Map({
  loading: true,
  accounts: Map(),
  settings: Map(),
  events: List(),
  initialEvents: List(),
  ticketSpotEvents: List(),
  nativeEvents: List(),
  calendars: List(),
  user: Map(),
  filters: Map(),
  organizers: List(),
  modals: Map(),
  journeySessionId: null,
});

const componentReducers = handleActions(
  {
    [startLoading]: (state) => state.set('loading', true),
    [endLoading]: (state) => state.set('loading', false),
    [updateSettingsProp]: (state, { payload: { key, value } }) => state.setIn(['settings', key], fromJS(value)),
    [fetchSettings]: (state, { payload }) => state.set('settings', fromJS(payload)),
    [updateSettings]: (state, { payload }) => state.update('settings', fromJS(payload)),
    [fetchEvents]: (state, { payload }) => state.set('events', fromJS(payload)).set('initialEvents', fromJS(payload)),
    [fetchTicketSpotEvents]: (state, { payload }) => state.set('ticketSpotEvents', fromJS(payload)).set('initialTicketSpotEvents', fromJS(payload)),
    [fetchNativeEventsAction]: (state, { payload }) => state.set('nativeEvents', fromJS(payload)),
    [filterEventsAction]: (state, { payload }) => {
      if (payload.values.length === 0) {
        return state.deleteIn(['filters', payload.filterType]);
      }
      return state.setIn(['filters', payload.filterType], Map({ values: payload.values }));
    },
    [fetchCalendars]: (state, { payload }) => state.set('calendars', fromJS(payload)),
    [fetchUser]: (state, { payload }) => state.set('user', fromJS(payload)),
    [fetchAccountsAction]: (state, { payload }) => state.set('accounts', fromJS(payload)),
    [fetchAccountAction]: (state, { payload }) => state.set('account', fromJS(payload)),
    [updateUserAction]: (state, { payload }) => state.set('user', fromJS(payload)),
    [fetchOrganizers]: (state, { payload }) => state.set('organizers', fromJS(payload)),
    [fetchOrganizationsAction]: (state, { payload }) => state.set('organizations', fromJS(payload)),
    [updateCampaignAction]: (state, { payload }) => state.set('campaigns', fromJS(payload)),
    [getCampaignsAction]: (state, { payload }) => state.set('campaigns', fromJS(payload)),
    [openModal]: (state, { payload }) => state.set('modals', { ...payload, show: true }),
    [closeModal]: (state, { payload }) => state.set('modals', { ...payload, show: false }),
    [setJourneySessionId]: (state, { payload }) => state.set('journeySessionId', payload),
  },
  initialState
);

export default componentReducers;
